import _ from 'lodash';
import { useEffect, useState } from 'react';
export function useCheckSuperPermsOnSuperuserChange(
// I can't make this type-safe with all the different forms
// eslint-disable-next-line @typescript-eslint/no-explicit-any
formMethods, permissionSystem) {
  const {
    getValues,
    setValue,
    formState,
    watch
  } = formMethods;
  const superuser = watch('superuser');

  // delay returned superuser value
  // so value changes and readonly changes happen at the same time
  const [superuserState, setSuperuserState] = useState(superuser);
  const superPermKeys = permissionSystem.superPerms;
  const superPermFormKeys = superPermKeys.map(([P, A]) => `permissions.${P}.${A}`);
  const superPermFormValues = getValues(superPermFormKeys);
  const shouldDirty = !!formState.dirtyFields?.superuser;
  useEffect(() => {
    setSuperuserState(superuser);
    if (superuser && _.some(superPermFormValues, x => !x)) {
      for (const p of superPermFormKeys) {
        setValue(p, true, {
          shouldDirty
        });
      }
    }
    if (!superuser && _.some(superPermFormValues)) {
      for (const p of superPermFormKeys) {
        setValue(p, false, {
          shouldDirty
        });
      }
    }
  }, [setValue, superPermFormKeys, superPermFormValues, shouldDirty, superuser]);
  return superuserState;
}